import { EmpresaWhatsappStruct } from '../../structs/chat-ai/empresa-whatsapp.struct';

export class WhatsappRequest {
  listaEmpresaWhatsapps: EmpresaWhatsappStruct[] = [];
}
